// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".debt-report__table[data-v-ea4b85ac] {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n@media (max-width: 700px) {\n.debt-report[data-v-ea4b85ac] {\n    padding-top: 25px;\n}\n}\n.debt-content[data-v-ea4b85ac] {\n  padding-top: 30px;\n}\n@media (max-width: 420px) {\n.debt-content[data-v-ea4b85ac] {\n      padding-top: 20px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
